module.exports = __webpack_public_path__ + "img/logo-new-24.a3a15d98.svg";